// @flow

import React from "react";
import styles from "./inputField.scss";

type Props = {
  name?: string,
  label?: string,
  type?: string,
  placeholder?: string,
  onChange?: Function,
  value?: any,
  disabled?: any,
  onBlur?: Function,
  onKeyPress?: Function,
  maxLength?: string,
  disabledClass?: any,
  inputFieldWrapperClass?: string
};

class InputField extends React.Component<Props> {
  constructor(props: Object) {
    super(props);
    this.state = {
      value: this.props.value != null ? this.props.value : ""
    };
  }

  componentWillReceiveProps(nextProps: Object) {
    if (nextProps && this.props.value !== nextProps.value) {
      this.setState({
        value: nextProps.value
      });
    }
  }

  onChangeHandler(val: string, target: any) {
    this.setState(
      {
        value:
          this.props.type === "number" && this.props.maxLength
            ? val.slice(0, Number(this.props.maxLength))
            : val
      },
      () => {
        this.props.onChange(val, target);
      }
    );
  }

  onBlurHandler(val: any) {
    if (this.props.onBlur) {
      this.props.onBlur(val);
    }
  }

  onKeyPressHandler(event: any) {
    if (this.props.onKeyPress) {
      this.props.onKeyPress(event);
    }
  }

  render() {
    return (
      <div
        className={`input-field-wrappper ${this.props.inputFieldWrapperClass ||
          ""}`}
      >
        {this.props.label ? (
          <div className={` ${styles.inputLabel} input-label `}>
            {this.props.label}
          </div>
        ) : null}
        <input
          className={` ${styles.inputField} ${
            this.props.disabled ? styles[this.props.disabledClass] : ""
          } input-field `}
          name={this.props.name}
          type={this.props.type}
          placeholder={this.props.placeholder}
          value={this.state.value}
          disabled={this.props.disabled || false}
          onChange={e => this.onChangeHandler(e.target.value, e.target)}
          onBlur={event => this.onBlurHandler(event.target.value)}
          maxLength={this.props.maxLength}
          onKeyPress={event => this.onKeyPressHandler(event)}
        />
      </div>
    );
  }
}

InputField.defaultProps = {
  name: null,
  label: null,
  type: null,
  placeholder: null,
  onChange: null,
  value: null,
  disabled: null,
  onBlur: null,
  onKeyPress: null,
  maxLength: null,
  disabledClass: null,
  inputFieldWrapperClass: null
};

export default InputField;



// WEBPACK FOOTER //
// ./app/components/commons/formElements/inputField/inputField.js